import { Badge } from "@components";
import { formatAmount, formatDateTime } from "@utils";

// A single row in the "Linked refunds" / "Linked payment" sections: a bold
// reference, an orange "View …" link (with icon) that navigates, a status
// badge, and an amount · date subtitle.
const LinkedTransactionItem = ({
  reference,
  linkLabel,
  icon: Icon,
  statusLabel,
  statusColor,
  amount,
  date,
  onClick,
}) => (
  <div className="px-5 py-4 flex flex-col gap-0.5">
    <div className="flex items-center justify-between gap-3">
      <div className="flex items-center gap-2">
        <span className="font-semibold text-zinc-900">{reference}</span>

        <div className="text-xs text-zinc-500">{formatDateTime(date)}</div>
      </div>
      {statusLabel && <Badge color={statusColor}>{statusLabel}</Badge>}
    </div>
    {onClick && (
      <button
        type="button"
        onClick={onClick}
        className="flex items-center gap-1.5 text-xs text-primary font-medium hover:underline"
      >
        {Icon && <Icon className="size-3" />}
        {linkLabel}
      </button>
    )}
  </div>
);

export default LinkedTransactionItem;
